import { nowIso } from '../domain/time.js';
export class ConfigRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    async get(key) {
        const rows = await this.driver.query({
            sql: 'SELECT value FROM local_config WHERE key = ?',
            params: [key],
        });
        return rows[0] ? String(rows[0].value) : null;
    }
    async set(key, value) {
        // Portable update-then-insert (minSdk 26 SQLite has no upsert; ADR-002).
        const now = nowIso();
        await this.driver.batch([
            { sql: 'UPDATE local_config SET value = ?, updated_at = ? WHERE key = ?', params: [value, now, key] },
            {
                sql: `INSERT INTO local_config (key, value, updated_at)
              SELECT ?, ?, ? WHERE (SELECT changes()) = 0`,
                params: [key, value, now],
            },
        ]);
    }
    async remove(key) {
        await this.driver.execute({ sql: 'DELETE FROM local_config WHERE key = ?', params: [key] });
    }
    async getJson(key) {
        const raw = await this.get(key);
        if (raw === null)
            return null;
        try {
            return JSON.parse(raw);
        }
        catch {
            return null;
        }
    }
    async setJson(key, value) {
        await this.set(key, JSON.stringify(value));
    }
}
//# sourceMappingURL=config.js.map